var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavPages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7778 15.1111H5.77778C5.6599 15.1111 5.54686 15.0643 5.46351 14.9809C5.38016 14.8976 5.33333 14.7846 5.33333 14.6667V4.8889C5.33333 4.77103 5.38016 4.65798 5.46351 4.57463C5.54686 4.49128 5.6599 4.44446 5.77778 4.44446H13.7778C13.8957 4.44446 14.0087 4.49128 14.092 4.57463C14.1754 4.65798 14.2222 4.77103 14.2222 4.8889V14.6667C14.2222 14.7846 14.1754 14.8976 14.092 14.9809C14.0087 15.0643 13.8957 15.1111 13.7778 15.1111ZM6.22222 14.2222H13.3333V5.33335H6.22222V14.2222Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11111 7.11108H12.4444V7.99997H7.11111V7.11108Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11111 8.88892H12.4444V9.7778H7.11111V8.88892Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11111 10.6667H12.4444V11.5556H7.11111V10.6667Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 10.6667V1.7778H10.6667V1.33336C10.6667 1.21549 10.6198 1.10244 10.5365 1.01909C10.4531 0.935741 10.3401 0.888916 10.2222 0.888916H2.22222C2.10435 0.888916 1.9913 0.935741 1.90795 1.01909C1.8246 1.10244 1.77778 1.21549 1.77778 1.33336V11.1111C1.77778 11.229 1.8246 11.3421 1.90795 11.4254C1.9913 11.5088 2.10435 11.5556 2.22222 11.5556H2.66667V10.6667Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44445 12.4445V3.55558H12.4444V3.11113C12.4444 2.99326 12.3976 2.88021 12.3143 2.79686C12.2309 2.71351 12.1179 2.66669 12 2.66669H4C3.88213 2.66669 3.76908 2.71351 3.68573 2.79686C3.60238 2.88021 3.55556 2.99326 3.55556 3.11113V12.8889C3.55556 13.0068 3.60238 13.1198 3.68573 13.2032C3.76908 13.2865 3.88213 13.3334 4 13.3334H4.44445V12.4445Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPages);
export default __webpack_public_path__ + "static/media/nav_pages.7f9961ad.svg";
export { ForwardRef as ReactComponent };